import { FC, useContext, useEffect, useState } from "react";

import useFetch from "src/hooks/useFetch";
import { downloadPdfFile } from "src/helpers/downloadFile";
import { LoaderContext } from "src/context/loaderContext";

import { DownloadZipResponseType } from "src/pages/dashboard/types";
import { APIEndpoints } from "src/types/apiTypes";
import { CaseDetailAPIResponse, CaseDetailProps, StepperType } from "./types";
import { doesBenefitHasInOrOutNetwork } from "src/helpers/stats";


const StepperModal: FC<StepperType> = ({ onClick, caseId }): JSX.Element => {
  const { hideLoader, setLoader } = useContext(LoaderContext);

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [activeTab, setActiveTab] = useState<string>('in_network');

  // Function to change the active tab
  // const handleTabClick = (tab: string) => {
  //   setActiveTab(tab);
  // };
  const { data: caseDetails } =
    useFetch<CaseDetailAPIResponse>(APIEndpoints.CASE_DETAIL_POPUP, { case_id: caseId })



  const {
    loading: downloadCaseLoader, data: downloadCaseData, error: downloadCaseError, mutate: downloadRequestForm, removeErrorAndData: clearRequestFileData
  } = useFetch<DownloadZipResponseType>(APIEndpoints.DOWNLOAD_REQUEST_FORM);

  useEffect(() => {
    if (downloadCaseData || downloadCaseError) {
      if (downloadCaseData && caseDetails) {
        const { response } = downloadCaseData;
        downloadPdfFile(response, `case_${caseId}_reports.pdf`);
      }
      hideLoader();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [downloadCaseData, downloadCaseError]);

  const downloadRequestFileByCaseId = () => {
    if (downloadCaseData || downloadCaseError) clearRequestFileData();
    setLoader();

    downloadRequestForm({}, {}, { ref_id: caseId, type: 'request', ref_type: 'Case', skip_pi: "true" });
  };

  const downloadInsuranceFileByCaseId = (insurance: CaseDetailProps) => {
    if (downloadCaseData || downloadCaseError) clearRequestFileData();
    setLoader();

    const benefit_type = doesBenefitHasInOrOutNetwork(insurance)
    downloadRequestForm({}, {}, { ref_id: insurance.insurance_id, type: 'investigation', ref_type: 'Insurance' , skip_pi_investigation: "true", benefit_type });
  };



  return (
    <div className={`modal fade show show show-modal`} id="typeModal" aria-labelledby="typeModalLabel" aria-hidden="true" >
      <div className="modal-dialog modal-dialog-scrollable modal-lg">
        <div className="modal-content">
          <div className="modal-header">
            <h1 className="text-center mb-0" style={{color:'#008853', fontSize:'1.875rem'}}>Case {caseId} Details
              <button disabled={downloadCaseLoader} id="request-link" className="btn btn-blue ms-2" onClick={downloadRequestFileByCaseId}>
                <i className="bi bi-file-pdf-fill"></i> Request
              </button>
            </h1>

            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={onClick}></button>
          </div>

          <div className="modal-body">
            <div className="card mb-3">
              <div className="row">
                <div className="col-md-3">
                  <b>Dx Code(s):</b>
                </div>
               
                  {
                    <div className="col-md-3">{caseDetails && caseDetails.data &&
                      Array.isArray(caseDetails.data) && caseDetails.data.length > 0 && caseDetails.data[0].dx_code } </div>
                   
                    }
                  <div className="col-md-3">
                  <b>Indication::</b>
                </div>
               
                  {
                    <div className="col-md-3">{caseDetails && caseDetails.data &&
                      Array.isArray(caseDetails.data) && caseDetails.data.length > 0 && caseDetails.data[0].indication } </div>
                   
                    }                
              </div>
            </div>

            {caseDetails && caseDetails.data ?
              (Array.isArray(caseDetails.data) && caseDetails.data.length > 0 ?
                caseDetails.data.map((kase: CaseDetailProps) => (
                  <div className="card mb-3" key={kase.case_id}>
                    <div className="card-header bg-success-subtle">
                      <div className="row">
                        <div className="col-md-3 fw-bold">
                          <b>Insurance Name:</b>
                        </div>
                        <div className="col-md-6 fw-bold">
                          {kase.insurance_name}
                        </div>
                        <div className="col-md-3 pr-0 text-end">
                          <button className="btn btn-blue ms-2" disabled={downloadCaseLoader} onClick={() => downloadInsuranceFileByCaseId(kase)}>
                          <i className="bi bi-file-pdf-fill"></i> Results
                          </button>
                        </div>
                      </div>
                    </div>

                    <div className="card-body">
                      {/* <ul className="nav nav-tabs">
                        <li className="nav-item">
                          <a className="nav-link" href="#">In Network</a>
                        </li>
                        <li className="nav-item">
                          <a className="nav-link" href="#">Out Network</a>
                        </li>

                      </ul> */}
                      {/* <ul className="nav nav-tabs">
                        <li className="nav-item">
                          <a
                            className={`nav-link ${activeTab === 'inNetwork' ? 'active' : ''}`}
                            href="#inNetwork"
                            onClick={(e) => {
                              e.preventDefault();
                              handleTabClick('inNetwork');
                            }}
                          >
                            In Network
                          </a>
                        </li>
                        <li className="nav-item">
                          <a
                            className={`nav-link ${activeTab === 'outNetwork' ? 'active' : ''}`}
                            href="#outNetwork"
                            onClick={(e) => {
                              e.preventDefault();
                              handleTabClick('outNetwork');
                            }}
                          >
                            Out of Network
                          </a>
                        </li>
                      </ul> */}

                      {/* Tab Content */}
                      <div className="tab-content mt-3">
                        {/* In Network Content */}
                        <div
                          id="inNetwork"
                          className={`tab-pane ${activeTab === 'in_network' ? 'show active' : ''}`}
                        >
                          <div className="row">
                            <div className="col-md-3">
                              <b>Product Coverage:</b>
                            </div>
                            <div className="col-md-3">
                              {kase.in_network_tab && kase.in_network_tab.product_coverage } 
                            </div>
                            <div className="col-md-3">
                              <b>Product Copay:</b>
                            </div>
                            <div className="col-md-3">
                                {kase.in_network_tab && kase.in_network_tab.product_copay }
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-md-3">
                              <b>Admin Coverage:</b>
                            </div>
                            <div className="col-md-3">
                              {kase.in_network_tab && kase.in_network_tab.admin_coverage} 
                            </div>
                            <div className="col-md-3">
                              <b>Admin copay:</b>
                            </div>
                            <div className="col-md-3">
                                {kase.in_network_tab && kase.in_network_tab.admin_copay }
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-md-3">
                              <b>Office Coverage:</b>
                            </div>
                            <div className="col-md-3">
                              {kase.in_network_tab && kase.in_network_tab.office_coverage} 
                            </div>
                            <div className="col-md-3">
                              <b>Office Copay:</b>
                            </div>
                            <div className="col-md-3">
                                {kase.in_network_tab && kase.in_network_tab.office_copay }
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-md-3">
                              <b>Deductible Met:</b>
                            </div>
                            <div className="col-md-3">
                                {kase.in_network_tab && kase.in_network_tab.deductible_met }
                            </div>
                            <div className="col-md-3">
                              <b>Deductible:</b>
                            </div>
                            <div className="col-md-3">
                                {kase.in_network_tab && kase.in_network_tab.deductible}
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-md-3">
                              <b>Out of Pocket Met:</b>
                            </div>
                            <div className="col-md-3">
                              {kase.in_network_tab && kase.in_network_tab.out_of_pocket_met }
                            </div>
                            <div className="col-md-3">
                              <b>Out of Packet Max:</b>
                            </div>
                            <div className="col-md-3">
                                {kase.in_network_tab && kase.in_network_tab.out_of_pocket_max }
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-md-3">
                              <b>Med Ben Notes:</b>
                            </div>
                            <div className="col-md-9">
                              {kase.in_network_tab && kase.in_network_tab.med_ben_notes }
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-md-3">
                              <b>RX Ben Notes:</b>
                            </div>
                            <div className="col-md-9">
                              {/* {caseDetails && caseDetails.data &&
                              Array.isArray(caseDetails.data) && caseDetails.data.length > 0 && caseDetails.data[0].rx_ben_notes } */}
                              {kase.rx_ben_notes}
                            </div>
                          </div>
                        </div>
                       

                        {/* Out of Network Content */}
                        <div
                          id="outNetwork"
                          className={`tab-pane ${activeTab === 'out_network' ? 'show active' : ''}`}
                        >
                         
                            <div className="row">
                              <div className="col-md-3">
                                <b>Product Coverage:</b>
                              </div>
                              <div className="col-md-3">
                                {kase.out_network_tab &&  kase.out_network_tab.product_coverage} 
                              </div>
                              <div className="col-md-3">
                                <b>Product Copay:</b>
                              </div>
                              <div className="col-md-3">
                                 {kase.out_network_tab &&  kase.out_network_tab.product_copay}
                              </div>
                            </div>
                            <div className="row">
                              <div className="col-md-3">
                                <b>Admin Coverage:</b>
                              </div>
                              <div className="col-md-3">
                                {kase.out_network_tab &&  kase.out_network_tab.admin_coverage} 
                              </div>
                              <div className="col-md-3">
                                <b>Admin copay:</b>
                              </div>
                              <div className="col-md-3">
                                 {kase.out_network_tab &&  kase.out_network_tab.admin_copay}
                              </div>
                            </div>
                            <div className="row">
                              <div className="col-md-3">
                                <b>Office Coverage:</b>
                              </div>
                              <div className="col-md-3">
                                {kase.out_network_tab &&  kase.out_network_tab.office_coverage} 
                              </div>
                              <div className="col-md-3">
                                <b>Office Copay:</b>
                              </div>
                              <div className="col-md-3">
                                 {kase.out_network_tab &&  kase.out_network_tab.office_copay}
                              </div>
                            </div>
                            <div className="row">
                              <div className="col-md-3">
                                <b>Deductible Met:</b>
                              </div>
                              <div className="col-md-3">
                                 {kase.out_network_tab &&  kase.out_network_tab.deductible_met}
                              </div>
                              <div className="col-md-3">
                                <b>Deductible:</b>
                              </div>
                              <div className="col-md-3">
                                 {kase.out_network_tab &&  kase.out_network_tab.deductible}
                              </div>
                            </div>
                            <div className="row">
                              <div className="col-md-3">
                                <b>Out of Pocket Met:</b>
                              </div>
                              <div className="col-md-3">
                                 {kase.out_network_tab &&  kase.out_network_tab.out_of_pocket_met}
                              </div>
                              <div className="col-md-3">
                                <b>Out of Packet Max:</b>
                              </div>
                              <div className="col-md-3">
                                 {kase.out_network_tab &&  kase.out_network_tab.out_of_pocket_max}
                              </div>
                            </div>
                            <div className="row">
                              <div className="col-md-3">
                                <b>Med Ben Notes:</b>
                              </div>
                              <div className="col-md-9">
                                {kase.out_network_tab &&  kase.out_network_tab.med_ben_notes}
                              </div>
                            </div>
                            <div className="row">
                              <div className="col-md-3">
                                <b>Rx Ben Notes:</b>
                              </div>
                              <div className="col-md-9">
                              {/* {caseDetails && caseDetails.data &&
                                Array.isArray(caseDetails.data) && caseDetails.data.length > 0 && caseDetails.data[0].rx_ben_notes } */}
                                {kase.rx_ben_notes}
                              </div>
                            </div>
                          </div>
                        </div>
                     
                      {/* <div className="" id= ""> 
                      <div className="row">
                        <div className="col-md-3">
                          <b>Product Coverage:</b>
                        </div>
                        <div className="col-md-3">
                          {kase.out_network_display ? kase.out_network_tab.product_coverage : kase.in_network_tab.product_coverage} %
                        </div>
                        <div className="col-md-3">
                          <b>Product Copay:</b>
                        </div>
                        <div className="col-md-3">
                          $ {kase.out_network_display ? kase.out_network_tab.product_copay : kase.in_network_tab.product_copay}
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-3">
                          <b>Admin Coverage:</b>
                        </div>
                        <div className="col-md-3">
                          {kase.out_network_display ? kase.out_network_tab.admin_coverage : kase.in_network_tab.admin_coverage} %
                        </div>
                        <div className="col-md-3">
                          <b>Admin copay:</b>
                        </div>
                        <div className="col-md-3">
                          $ {kase.out_network_display ? kase.out_network_tab.admin_copay : kase.in_network_tab.admin_copay}
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-3">
                          <b>Office Coverage:</b>
                        </div>
                        <div className="col-md-3">
                          {kase.out_network_display ? kase.out_network_tab.office_coverage : kase.in_network_tab.office_coverage} %
                        </div>
                        <div className="col-md-3">
                          <b>Office Copay:</b>
                        </div>
                        <div className="col-md-3">
                          $ {kase.out_network_display ? kase.out_network_tab.office_copay : kase.in_network_tab.office_copay}
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-3">
                          <b>Deductible Met:</b>
                        </div>
                        <div className="col-md-3">
                          $ {kase.out_network_display ? kase.out_network_tab.deductible_met : kase.in_network_tab.deductible_met}
                        </div>
                        <div className="col-md-3">
                          <b>Deductible:</b>
                        </div>
                        <div className="col-md-3">
                          $ {kase.out_network_display ? kase.out_network_tab.deductible : kase.in_network_tab.deductible}
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-3">
                          <b>Out of Pocket Met:</b>
                        </div>
                        <div className="col-md-3">
                          $ {kase.out_network_display ? kase.out_network_tab.out_of_pocket_met : kase.in_network_tab.out_of_pocket_met}
                        </div>
                        <div className="col-md-3">
                          <b>Out of Packet Max:</b>
                        </div>
                        <div className="col-md-3">
                          $ {kase.out_network_display ? kase.out_network_tab.out_of_pocket_max : kase.in_network_tab.out_of_pocket_max}
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-3">
                          <b>Med Ben Notes:</b>
                        </div>
                        <div className="col-md-9">
                          {kase.out_network_display ? kase.out_network_tab.med_ben_notes : kase.in_network_tab.med_ben_notes}
                        </div>
                      </div>
                      </div> */}
                    </div>
                  </div>
                ))
                : <h4 className="text-center fw-bold">{(caseDetails.data as string)}</h4>)
              : null
            }
          </div>
        </div>
      </div>
    </div>
  );
};

export default StepperModal;

